import type { LocationData, PasswordPolicyType } from '@patrianna/shared-patrianna-types/store/AppConfigModule'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { SupportedCurrencies } from 'types/currencies'

import type { AppConfigState } from './types'

export const initialState: AppConfigState = {
  darkTheme: false,
  init: false,
  sweepstakeEnabled: false,
  useImageBasedCaptcha: false,
  passwordPolicy: {
    min: 8,
    max: 20,
    lowerCase: 1,
    upperCase: 1,
    special: 0,
    digits: 1,
    shouldNotMatchEmail: true,
  },
  goldCurrency: null,
  forcement: 'default',
  isPWAMessageOpen: false,
  location: null,
  softKycRequiredEnabled: null,
  thirdPartyCheckEnabled: false,
}

export const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    toggleDarkTheme: (state) => {
      state.darkTheme = !state.darkTheme
    },

    initApp: (state) => {
      state.init = true
    },

    savePasswordPolicy: (state, action: PayloadAction<{ passwordPolicy: PasswordPolicyType }>) => {
      state.passwordPolicy = action.payload.passwordPolicy
    },

    // @TODO will remove
    setGoldCurrency: (state, action: PayloadAction<{ goldCurrency: SupportedCurrencies }>) => {
      state.goldCurrency = action.payload.goldCurrency
    },

    saveLocationData: (state, action: PayloadAction<{ location: LocationData }>) => {
      state.location = action.payload.location
    },

    setSweepstakeEnabled: (state, action: PayloadAction<{ enabled: boolean }>) => {
      state.sweepstakeEnabled = action.payload.enabled
    },

    togglePWAMessage: (state, action: PayloadAction<{ isPWAMessageOpen: boolean }>) => {
      state.isPWAMessageOpen = action.payload.isPWAMessageOpen
    },

    // @TODO will remove
    setForcementMode: (state, action: PayloadAction<{ forcement: string }>) => {
      state.forcement = action.payload.forcement
    },

    // [FYI]: A/B testing 3rd party checks
    saveKYCRequiredField: (state, action: PayloadAction<{ softKycRequiredEnabled: boolean }>) => {
      state.softKycRequiredEnabled = action.payload.softKycRequiredEnabled
    },

    // [FYI]: A/B testing 3rd party checks
    saveThirdPartyCheckEnabled: (state, action: PayloadAction<{ thirdPartyCheckEnabled: boolean }>) => {
      state.thirdPartyCheckEnabled = action.payload.thirdPartyCheckEnabled || false
    },

    saveUseImageBasedCaptcha: (state, action: PayloadAction<{ useImageBasedCaptcha: boolean }>) => {
      state.useImageBasedCaptcha = action.payload.useImageBasedCaptcha
    },
  },
})

export type ActionsTypes = ReturnType<InferValueTypes<typeof appConfigSlice.actions>>
export const { actions } = appConfigSlice
